<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pro"> </p>
<p class="PN-S"><span href="#/xhtml/contents#c_pro" title="Link target outside of Sample">PROLOGUE</span></p>
<p class="EP">History is a guide to navigation in perilous times. History is who we are and why we are the way we are.</p>
<div class="SPACE">
<p class="EPC"><span class="ePub-B">—David McCullough</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?ede2f1d8